module.exports = __webpack_public_path__ + "img/typeicon.84fb2a21.png";